import { checkTeamForAICompliance } from "@redotech/redo-agents-common/util/compliance-util";
import AiStarOrangeIcon from "@redotech/redo-icons/ai-star-orange.svg";
import {
  RedoButton,
  type RedoButtonSize,
} from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo, useContext } from "react";
import { TeamContext } from "../team";
import { useAskRedoSlidePanel } from "./ask-redo-slide-panel-context";

export const AskRedoButton = memo(function AskRedoButton({
  text,
  size,
  disabled,
}: {
  text: string;
  size?: RedoButtonSize;
  disabled?: boolean;
}) {
  const { open, isOpen } = useAskRedoSlidePanel();
  const team = useContext(TeamContext);

  if (team && !checkTeamForAICompliance(team._id.toString())) {
    return null;
  }

  return (
    <RedoButton
      disabled={disabled}
      hierarchy="secondary"
      IconLeading={AiStarOrangeIcon}
      onClick={() => {
        if (!isOpen) {
          open();
        }
      }}
      size={size}
      text={text}
    />
  );
});
